import { render, staticRenderFns } from "./trash-paper-list.html?vue&type=template&id=7a380482&scoped=true&external"
import script from "./trash-paper-list.js?vue&type=script&lang=js&external"
export * from "./trash-paper-list.js?vue&type=script&lang=js&external"
import style0 from "./trash-paper-list.scss?vue&type=style&index=0&id=7a380482&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a380482",
  null
  
)

export default component.exports